export const en = {
    'many-platforms-count': '{selectedCount} of {totalCount} screens selected',
    'many-screens-count': '{selectedCount} screens',
    'nothing-found': 'No results found',
    'one-platforms-count': '{selectedCount} of {totalCount} screens',
    'one-screens-count': '{selectedCount} screen',
    'some-platforms-count': '{selectedCount} of {totalCount} screens',
    'some-screens-count': '{selectedCount} screens'
};
